export const companyInfo = {
  name: "Billund Varme & Sanitet A/S",
  owner: "v/ Mogens Brøgger",
  cvr: "29407320",
  address: "Montanavej 1B, 7190 Billund",
  phone: "75 33 12 76",
  email: "info@billundvvs.dk",
  experience: "Over 50 års erfaring",
  ownerExperience: "Mere end 25 års faglig erfaring",
  takeoverYear: "Overtaget i 2012"
};

export const services = [
  {
    id: "vvs",
    title: "VVS arbejde",
    shortDesc: "Alt fra service og reparation til rørinstallationer og badeværelser.",
    fullDesc: "Vil du gerne være sikker på, at dine installationer fungerer, som de skal, så lad Billund Varme & Sanitet A/S stå for VVS-arbejdet. Vi har mange års erfaring med alle typer opgaver inden for VVS-faget, og vores kundekreds tæller alt fra privatpersoner til virksomheder, foreninger og institutioner.",
    features: [
      "Installation & reparation",
      "Service på rørinstallationer",
      "Nyt badeværelse & renovering",
      "Forebyggelse af vandskader",
      "Gennemgang af skjulte installationer"
    ],
    cta: "Få gennemgået dine installationer",
    path: "/vvs-arbejde",
    image: "/images/vvs-pipes-technical.webp"
  },
  {
    id: "varme",
    title: "Varme & varmesystemer",
    shortDesc: "Optimering og service af varmeanlæg for bedre økonomi og komfort.",
    fullDesc: "Vi tilbyder en grundig gennemgang af dit varmesystem, så det fungerer optimalt. Uanset om du har brug for ny varmeforsyning eller renovering af de eksisterende rørinstallationer, sikrer vi en løsning der virker.",
    features: [
      "Optimering af varmeanlæg",
      "Varmestyring & service",
      "Lavere varmeforbrug",
      "Renovering af anlæg",
      "Professionel rådgivning"
    ],
    cta: "Få rådgivning om varme",
    path: "/varme",
    image: "/images/utility-room-heating.webp"
  },
  {
    id: "varmepumper",
    title: "Varmepumper",
    shortDesc: "Effektive varmepumpeløsninger med professionel opsætning og service.",
    fullDesc: "Vi tilbyder løbende service, professionel varmestyring og levering og opsætning af nye varmeinstallationer. Et effektivt varmesystem gavner både komfort og økonomi.",
    features: [
      "Luft-til-vand varmepumper",
      "Professionel levering & opsætning",
      "Løbende serviceaftaler",
      "Rådgivning om tilskud",
      "Høj driftssikkerhed"
    ],
    cta: "Få et tilbud på varmepumpe",
    path: "/varmepumper",
    image: "/images/heat-pump-outside.webp"
  },
  {
    id: "ventilation",
    title: "Ventilation",
    shortDesc: "Sikring af et sundt indeklima gennem moderne ventilationsanlæg.",
    fullDesc: "Vi installerer og renoverer også ventilationsanlæg for både private og erhverv. Et godt ventilationsanlæg er afgørende for et sundt indeklima og forebyggelse af fugtproblemer.",
    features: [
      "Installation af anlæg",
      "Renovering af ventilation",
      "Service & vedligeholdelse",
      "Bedre indeklima",
      "Energioptimering"
    ],
    cta: "Kontakt os om ventilation",
    path: "/ventilation",
    image: "/images/ventilation-system.webp"
  },
  {
    id: "badevaerelser",
    title: "Badeværelser",
    shortDesc: "Nyt badeværelse eller totalrenovering af eksisterende rum.",
    fullDesc: "Vi hjælper dig med at realisere drømmen om et nyt badeværelse. Vi koordinerer opgaven og sikrer, at alle VVS-installationer er udført korrekt og i højeste kvalitet.",
    features: [
      "Totalrenovering",
      "Nyt armatur & sanitet",
      "Vandbesparende løsninger",
      "Modernisering",
      "Professionel finish"
    ],
    cta: "Få tilbud på badeværelse",
    path: "/vvs-arbejde",
    image: "/images/modern-bathroom-detail.webp"
  }
];

export const trustPoints = [
  { title: "50+ års erfaring", desc: "Solid erfaring i Billund" },
  { title: "Mogens Brøgger", desc: "25+ års faglig viden" },
  { title: "Alt i VVS & Varme", desc: "Private og erhverv" },
  { title: "Lokalt fokus", desc: "Løsninger der holder" }
];
